/** * 弹窗演示 * 徐杰 * 2019-4-22 **/
<template>
  <div>
    <X-Layout>
      <!-- 位置条 -->
      <div style="position: relative; display: flex; justify-content: space-between; height: 28px; line-height: 28px">
        <Breadcrumb>
          <BreadcrumbItem to="/home"> <Icon type="icon iconfont icon-xitong" /> 系统首页 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-xitonghoutai" /> 系统管理 </BreadcrumbItem>
          <BreadcrumbItem> <Icon type="icon iconfont icon-qiye" /> 企业管理 </BreadcrumbItem>
        </Breadcrumb>
        <i-button class="refresh" size="small" type="success">
          <Icon title="刷新" class="icon" type="ios-refresh" @click="reload" />
        </i-button>
      </div>
      <!-- 内容区域 -->
      <Card style="margin-top: 12px">
        <!-- 搜索栏 -->
        <div class="optdiv">
          <div>
            <Button type="primary" @click="addcompany()">
              <Icon type="md-add" style="position: relative; top: -0.125rem" />&nbsp;新增企业</Button
            >
          </div>
          <div>
            <i-input
              v-model="company_name"
              prefix="ios-search"
              class="tabdiv"
              placeholder="搜索企业名称"
              style="width: 200px"
              @on-change="searchCompanynameInfo(1)"
            />
            <Select v-model="optId" style="width: 200px; margin-left: 10px" @on-change="searchCompanynameInfo(1)">
              <Option v-for="item in optList" :value="item.id" :key="item.id">{{ item.label }}</Option>
            </Select>
          </div>
        </div>
        <!-- 数据表格 -->
        <i-table width="100%" :loading="tbLoading" :columns="columns2" :data="companylist">
          <template slot="action" slot-scope="params">
            <Button type="primary" size="small" style="margin-right: 5px" @click="show2(params.row.company_id)"
              >修改</Button
            >
            <Button
              type="warning"
              size="small"
              style="margin-right: 5px"
              @click="show3(params.row.company_id, params.row.type, params.row.company_name)"
              >管理</Button
            >
            <Button
              type="info"
              size="small"
              style="margin-right: 5px"
              @click="show4(params.row.company_id, params.row.street_id)"
              >场照</Button
            >
            <Icon
              type="ios-trash"
              title="删除"
              style="margin-right: 5px; font-size: 24px; cursor: pointer; color: #ed4014"
              @click="deldata(params.row.company_id)"
            />
          </template>
        </i-table>
        <!-- 分页 -->
        <Page
          style="margin-top: 0.625rem"
          :current.sync="page"
          :page-size-opts="[20, 50, 100, 200, 500]"
          :page-size="row"
          show-total
          :total="total"
          show-sizer
          @on-change="onNextPage"
          @on-page-size-change="onPageSize"
        />
      </Card>

      <Modal v-model="modal1" title="删除提示" ok-text="确定删除" @on-ok="ok" @on-cancel="cancel">
        <Alert type="warning" show-icon>
          <template slot="desc"> 你确定要删除这个公司吗？你的删除可能会影响接受端的程序出现错误！ </template>
        </Alert>
      </Modal>
    </X-Layout>
  </div>
</template>

<script>
import { checkOptionList } from '@/utils/common';
export default {
  data() {
    return {
      optId: -1,
      // 0工况 1油烟 2在线
      optList: checkOptionList,
      company_name: '',
      modal1: false,
      listindex: '', // 删除数组中的第几个数据
      tbLoading: false, // 加载动画
      columns2: [
        {
          type: 'index',
          title: '序号',
          minWidth: 90,
          align: 'center',
          indexMethod: row => {
            return row._index + 1 + this.page * this.row - this.row;
          },
        },
        {
          title: '企业名称',
          key: 'company_name',
          align: 'center',
          minWidth: 180,
          sortable: true,
        },
        {
          title: '地址',
          key: 'address',
          align: 'center',
          minWidth: 200,
        },
        {
          title: '联系人',
          key: 'legalPerson',
          align: 'center',
          minWidth: 80,
        },
        {
          title: '联系方式',
          key: 'phone',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '地区',
          key: 'area_name',
          align: 'center',
          minWidth: 100,
        },
        {
          title: '行业',
          key: 'industry',
          align: 'center',
          minWidth: 100,
          sortable: true,
        },
        {
          title: '监测项',
          align: 'center',
          minWidth: 150,
          sortable: true,
          key: 'show',
          render: (h, params) => {
            const _list = params.row.sitesName; // 按,切换数组

            if (_list) {
              // 不为空的 才输出格式
              let _color;
              switch (_list) {
                case '工况':
                  _color = 'blue';
                  break;
                case '在线':
                  _color = 'yellow';
                  break;
                case '油烟':
                  _color = 'green';
                  break;
                case '扬尘':
                  _color = 'pink';
                  break;
              }
              return h(
                'Tag',
                {
                  props: {
                    color: _color,
                  },
                },
                _list,
              );
            }
          },
        },
        {
          title: '操作',
          // key: 'action',
          fixed: 'right',
          width: 230,
          align: 'center',
          slot: 'action', // 使用 slot-scope 写法
        },
      ],

      companylist: [], // 公司列表
      page: 1, // 页数
      row: 20, // 条数
      total: 0, // 总条数
    };
  },

  mounted() {
    this.searchCompanynameInfo(1);
  },
  methods: {
    /**
     * 搜索公司
     */
    searchCompanynameInfo(page) {
      const api = this.ApiUrl + 'company/findAllCompany';
      const params = {
        pageNo: page,
        pageSize: this.row,
        companyName: this.company_name,
      };

      if (this.optId != -1) {
        params.type = this.optId;
      }

      this.tbLoading = true; // 开启加载动画
      this.$http.get(api, { params }).then(
        res => {
          if (res.data.extend.news === 0) {
            let list = res.data.extend.pageInfo;
            this.companylist = list.records || 0;
            this.total = list.total;
          }
          this.tbLoading = false; // 关闭加载动画
        },
        res => {
          this.tbLoading = false; // 关闭加载动画
        },
      );
    },
    /**
     * 确认删除
     */
    ok() {
      const api = this.ApiUrl + 'company/delById';
      const data = {
        company_id: this.listindex,
      };
      this.$http.post(api, data).then(
        res => {
          if (res.status == 200) {
            this.searchCompanynameInfo(this.page);
            this.$Message.success('成功删除');
          } else {
            this.$Message.warning(res.data.extend.msg);
          }
        },
        res => {},
      );
    },
    cancel() {
      this.$Message.info('取消删除');
    },

    // 表格删除事件
    deldata(index) {
      this.modal1 = true;
      this.listindex = index;
    },
    // 表格事件处理
    show2(index) {
      sessionStorage.setItem('admid', index);
      this.$router.push({
        name: 'updatacompany',
        params: {
          comid: index,
        },
      });
    },
    show4(index, id) {
      this.$router.push({
        name: 'newshebei',
        query: {
          comid: index,
        },
      });
    },
    show3(index, id, companyName) {
      sessionStorage.setItem('admid', index);
      sessionStorage.setItem('companyName', companyName);
      if (id === 0) {
        sessionStorage.setItem('yytype', 0);
      } else if (id === 1) {
        sessionStorage.setItem('yytype', 1);
      } else if (id == 2) {
        sessionStorage.setItem('yytype', 2);
      } else {
        sessionStorage.setItem('yytype', 3);
      }

      this.$router.push({
        name: 'newcompany',
        query: {
          comid: index,
        },
      });
    },
    // 添加公司
    addcompany() {
      this.$router.push({
        name: 'addcompany',
      });
    },
    // 切换显示的页数
    onPageSize(e) {
      this.row = e;
      this.searchCompanynameInfo(1);
    },
    // 切换下一页
    onNextPage(e) {
      this.searchCompanynameInfo(e);
    },
    // 刷新页面
    reload() {
      location.reload();
    },
    /**
     * 跳转到添加企业
     */
    toAddCompany() {
      this.$router.push({
        name: 'newcompany',
        params: {
          admid: 123,
        },
      });
    },
  },
};
</script>

<style scoped>
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  font-size: 1.5rem;
}

.refresh {
  float: right;
  margin-right: 1.25rem;
}

.optdiv {
  display: flex;
  padding: 0.625rem 0;
  justify-content: space-between;
}

.tabdiv {
  margin-left: 1.25rem;
}
</style>
